/**
 * @generated SignedSource<<b3e929c4699f41eef5c71b185f1ed7dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespTopModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_user">;
  readonly " $fragmentType": "PdpRespTopModule_user";
};
export type PdpRespTopModule_user$key = {
  readonly " $data"?: PdpRespTopModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespTopModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTopModule_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1927c99505d32894ee58bce4ea4e09c9";

export default node;
